export const menuData = {
  sandwich: [
    {
      id: 1,
      name: "New머쉬룸",
      eng: "NewMushroom",
      price: 6400,
      image: process.env.PUBLIC_URL + "/images/sandwich/sandwich01.png",
    },
    {
      id: 2,
      name: "안창 비프&New머쉬룸",
      eng: "Beef&New Mushroom",
      price: 8900,
      image: process.env.PUBLIC_URL + "/images/sandwich/sandwich02.png",
    },
    {
      id: 3,
      name: "이탈리안 비엠티",
      eng: "Italian B.M.T.™",
      price: 7200,
      image: process.env.PUBLIC_URL + "/images/sandwich/sandwich03.png",
    },
    {
      id: 4,
      name: "스테이크&치즈",
      eng: "Steak & Cheese",
      price: 8500,
      image: process.env.PUBLIC_URL + "/images/sandwich/sandwich04.png",
    },
    {
      id: 5,
      name: "로티세리 바비큐 치킨",
      eng: "Rotisserie Barbecue Chicken",
      price: 6400,
      image: process.env.PUBLIC_URL + "/images/sandwich/sandwich05.png",
    },
    {
      id: 6,
      name: "에그마요",
      eng: "Egg Mayo",
      price: 5900,
      image: process.env.PUBLIC_URL + "/images/sandwich/sandwich06.png",
    },
    {
      id: 7,
      name: "안창 비프",
      eng: "Beef",
      price: 11700,
      image: process.env.PUBLIC_URL + "/images/sandwich/sandwich07.png",
    },
    {
      id: 8,
      name: "터키 베이컨 아보카도",
      eng: "Turkey Bacon Avocado",
      price: 9600,
      image: process.env.PUBLIC_URL + "/images/sandwich/sandwich08.png",
    },
    {
      id: 9,
      name: "스파이시 쉬림프",
      eng: "Spicy Shrimp",
      price: 9000,
      image: process.env.PUBLIC_URL + "/images/sandwich/sandwich09.png",
    },
    {
      id: 10,
      name: "쉬림프",
      eng: "Shirmp",
      price: 7900,
      image: process.env.PUBLIC_URL + "/images/sandwich/sandwich10.png",
    },
    {
      id: 11,
      name: "로스트 치킨",
      eng: "Roasted Chicken",
      price: 7800,
      image: process.env.PUBLIC_URL + "/images/sandwich/sandwich11.png",
    },
    {
      id: 12,
      name: "폴드포크 바비큐",
      eng: "Pulled Pork Barbecue",
      price: 7600,
      image: process.env.PUBLIC_URL + "/images/sandwich/sandwich12.png",
    },
    {
      id: 13,
      name: "써브웨이 클럽",
      eng: "Subway Club",
      price: 7500,
      image: process.env.PUBLIC_URL + "/images/sandwich/sandwich13.png",
    },
    {
      id: 14,
      name: "치킨 데리야끼",
      eng: "Chicken Teriyaki",
      price: 7400,
      image: process.env.PUBLIC_URL + "/images/sandwich/sandwich14.png",
    },
    {
      id: 15,
      name: "스파이시 이탈리안",
      eng: "Spicy Italian",
      price: 7200,
      image: process.env.PUBLIC_URL + "/images/sandwich/sandwich15.png",
    },
    {
      id: 16,
      name: "비엘티",
      eng: "B.L.T",
      price: 7100,
      image: process.env.PUBLIC_URL + "/images/sandwich/sandwich16.png",
    },
    {
      id: 17,
      name: "터키",
      eng: "Turkey",
      price: 6900,
      image: process.env.PUBLIC_URL + "/images/sandwich/sandwich17.png",
    },
    {
      id: 18,
      name: "참치",
      eng: "Tuna",
      price: 6200,
      image: process.env.PUBLIC_URL + "/images/sandwich/sandwich18.png",
    },
  ],
  salad: [
    {
      id: 1,
      name: "폴드포크 타코 샐러드",
      eng: "Pulled Pork Taco Salad",
      price: 11900,
      image: process.env.PUBLIC_URL + "/images/salad/salad01.png",
    },
    {
      id: 2,
      name: "스파이시 쉬림프 타코 샐러드",
      eng: "Spicy Shrimp Taco Salad",
      price: 13200,
      image: process.env.PUBLIC_URL + "/images/salad/salad02.png",
    },
    {
      id: 3,
      name: "로티세리 치킨 타코 샐러드",
      eng: "Rotisserie Chicken Taco Salad",
      price: 12500,
      image: process.env.PUBLIC_URL + "/images/salad/salad03.png",
    },
    {
      id: 4,
      name: "안창 비프",
      eng: "Beef",
      price: 12800,
      image: process.env.PUBLIC_URL + "/images/salad/salad04.png",
    },
    {
      id: 5,
      name: "안창 비프 & New머쉬룸",
      eng: "Beef & New Mushroom",
      price: 12800,
      image: process.env.PUBLIC_URL + "/images/salad/salad05.png",
    },
    {
      id: 6,
      name: "New 머쉬룸",
      eng: "New Mushroom",
      price: 8400,
      image: process.env.PUBLIC_URL + "/images/salad/salad06.png",
    },
    {
      id: 7,
      name: "이탈리안 비엠티",
      eng: "Italian B.M.T™",
      price: 9200,
      image: process.env.PUBLIC_URL + "/images/salad/salad07.png",
    },
    {
      id: 8,
      name: "비엘티",
      eng: "B.L.T.",
      price: 9100,
      image: process.env.PUBLIC_URL + "/images/salad/salad08.png",
    },
    {
      id: 9,
      name: "햄",
      eng: "Ham",
      price: 8200,
      image: process.env.PUBLIC_URL + "/images/salad/salad09.png",
    },
    {
      id: 10,
      name: "참치",
      eng: "Tuna",
      price: 8200,
      image: process.env.PUBLIC_URL + "/images/salad/salad10.png",
    },
    {
      id: 11,
      name: "에그마요",
      eng: "Egg Mayo",
      price: 7900,
      image: process.env.PUBLIC_URL + "/images/salad/salad11.png",
    },
    {
      id: 12,
      name: "폴드포크 바비큐",
      eng: "Pulled Pork Barbecue",
      price: 9600,
      image: process.env.PUBLIC_URL + "/images/salad/salad12.png",
    },
    {
      id: 13,
      name: "로티세리 바비큐 치킨",
      eng: "Rotisserie Barbecue Chicken",
      price: 9800,
      image: process.env.PUBLIC_URL + "/images/salad/salad13.png",
    },
    {
      id: 14,
      name: "쉬림프",
      eng: "Shrimp",
      price: 9900,
      image: process.env.PUBLIC_URL + "/images/salad/salad14.png",
    },
    {
      id: 15,
      name: "터키 베이컨 아보카도",
      eng: "Turkey Bacon Avocado",
      price: 10700,
      image: process.env.PUBLIC_URL + "/images/salad/salad15.png",
    },
    {
      id: 16,
      name: "써브웨이 클럽",
      eng: "Subway Club",
      price: 9500,
      image: process.env.PUBLIC_URL + "/images/salad/salad16.png",
    },
    {
      id: 17,
      name: "에그 슬라이스",
      eng: "Egg Slice",
      price: 7400,
      image: process.env.PUBLIC_URL + "/images/salad/salad17.png",
    },
    {
      id: 18,
      name: "스파이시 쉬림프",
      eng: "Spicy Shrimp",
      price: 10100,
      image: process.env.PUBLIC_URL + "/images/salad/salad18.png",
    },
    {
      id: 19,
      name: "스파이시 이탈리안",
      eng: "Spicy Italian",
      price: 9200,
      image: process.env.PUBLIC_URL + "/images/salad/salad19.png",
    },
    {
      id: 20,
      name: "스테이크 & 치즈",
      eng: "Steak & Cheese",
      price: 10500,
      image: process.env.PUBLIC_URL + "/images/salad/salad20.png",
    },
    {
      id: 21,
      name: "로스트 치킨",
      eng: "Roasted Chicken",
      price: 9800,
      image: process.env.PUBLIC_URL + "/images/salad/salad21.png",
    },
    {
      id: 22,
      name: "치킨 데리야끼",
      eng: "Chicken Teriyaki",
      price: 9400,
      image: process.env.PUBLIC_URL + "/images/salad/salad22.png",
    },
    {
      id: 23,
      name: "터키",
      eng: "Turkey",
      price: 8900,
      image: process.env.PUBLIC_URL + "/images/salad/salad23.png",
    },
    {
      id: 24,
      name: "베지",
      eng: "Veggie Delite",
      price: 7100,
      image: process.env.PUBLIC_URL + "/images/salad/salad24.png",
    },
    {
      id: 25,
      name: "미니 로티세리 치킨 샐러드",
      eng: "Mini Rotisserie Chicken Salad",
      price: 2900,
      image: process.env.PUBLIC_URL + "/images/salad/salad25.png",
    },
  ],
  side: [
    {
      id: 1,
      name: "포테이토 베이컨 수프",
      eng: "Potato Bacon Soup",
      price: 2100,
      image: process.env.PUBLIC_URL + "/images/sideMenu/side01.png",
    },
    {
      id: 2,
      name: "콘 수프",
      eng: "Corn Soup",
      price: 2100,
      image: process.env.PUBLIC_URL + "/images/sideMenu/side02.png",
    },
    {
      id: 3,
      name: "머쉬룸 수프",
      eng: "Mushroom Soup",
      price: 2100,
      image: process.env.PUBLIC_URL + "/images/sideMenu/side03.png",
    },
    {
      id: 4,
      name: "오렌지 초코칩 쿠키",
      eng: "Orange Chocolate Chip",
      price: 1500,
      image: process.env.PUBLIC_URL + "/images/sideMenu/side04.png",
    },
    {
      id: 5,
      name: "초코칩",
      eng: "Chocolate Chip",
      price: 1500,
      image: process.env.PUBLIC_URL + "/images/sideMenu/side05.png",
    },
    {
      id: 6,
      name: "더블 초코칩",
      eng: "Double Chocolate Chip",
      price: 1500,
      image: process.env.PUBLIC_URL + "/images/sideMenu/side06.png",
    },
    {
      id: 7,
      name: "오트밀 레이즌",
      eng: "Oatmeal Raisin",
      price: 1500,
      image: process.env.PUBLIC_URL + "/images/sideMenu/side07.png",
    },
    {
      id: 8,
      name: "라즈베리 치즈케익",
      eng: "Raspberry Cheese Cake",
      price: 1500,
      image: process.env.PUBLIC_URL + "/images/sideMenu/side08.png",
    },
    {
      id: 9,
      name: "화이트 초코 마카다미아",
      eng: "White Choco Macadamia",
      price: 1500,
      image: process.env.PUBLIC_URL + "/images/sideMenu/side09.png",
    },
    {
      id: 10,
      name: "웨지 포테이토",
      eng: "Ovenbaked Wedge Potatoes",
      price: 2000,
      image: process.env.PUBLIC_URL + "/images/sideMenu/side10.jpg",
    },
    {
      id: 11,
      name: "Cheesy 웨지 포테이토",
      eng: "Cheesy Ovenbaked Wedge Potatoes",
      price: 2500,
      image: process.env.PUBLIC_URL + "/images/sideMenu/side11.jpg",
    },
    {
      id: 12,
      name: "Bacon Cheesy 웨지 포테이토",
      eng: "Bacon Cheesy Ovenbaked Wedge Potatoes",
      price: 2900,
      image: process.env.PUBLIC_URL + "/images/sideMenu/side12.jpg",
    },
    {
      id: 13,
      name: "스테이크&치즈 아보카도 랩",
      eng: "Steak&Cheese Avocado Wrap",
      price: 6900,
      image: process.env.PUBLIC_URL + "/images/sideMenu/side13.png",
    },
    {
      id: 14,
      name: "쉬림프 에그마요 랩",
      eng: "Shrimp Egg Mayo Wrap",
      price: 6500,
      image: process.env.PUBLIC_URL + "/images/sideMenu/side14.png",
    },
    {
      id: 15,
      name: "치킨 베이컨 미니 랩",
      eng: "Chicken Bacon Mini Wrap",
      price: 6500,
      image: process.env.PUBLIC_URL + "/images/sideMenu/side15.png",
    },
    {
      id: 16,
      name: "칩",
      eng: "Chips",
      price: 1000,
      image: process.env.PUBLIC_URL + "/images/sideMenu/side16.png",
    },
  ],
  drink: [
    {
      id: 1,
      name: "커피",
      eng: "coffee",
      price: 1500,
      image: process.env.PUBLIC_URL + "/images/drink/drink01.png",
    },
    {
      id: 2,
      name: "음료수",
      eng: "coffee",
      price: 1500,
      image: process.env.PUBLIC_URL + "/images/drink/drink02.png",
    },
  ],
};
